import axios from 'axios';

export const API = 'http://api.theacademy.co.ug'
export const resources = {
    'timeline': 'timeline',
    'chapter': 'chapter',
    'icons': 'icons',
    'about': 'about',
    'sponsors': 'sponsors',
    'acknowledgements': 'acknowledgements',
    'contact': 'contact',
    'quiz': 'quiz',
    'nodeEntity': '/entity/node?_format=json'
}

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'username': '',
    'password': ''
}

export const historyRequest = axios.create({
    baseURL: `${API}`,
    headers: headers,
    timeout: 10000,
})
